<template>
  <v-dialog :value="!!cliente" max-width="600" persistent>
    <v-card v-if="cliente" dark color="quinta">
      <v-card-title>{{ cliente.sold == null ? 'Regularizar distribuidora' : 'Trocar distribuidora' }}</v-card-title>
      <v-card-text>
        <p><strong>{{ cliente.nomeFantasia }}</strong><br>{{ cliente.cnpjCpf }} · {{ cliente.cidade }}</p>
        <p>Vínculo atual: {{ descricao(cliente) }}</p>
        <v-alert v-if="erro || catalogo.erro" type="error" outlined>{{ erro || catalogo.erro }}
          <v-btn v-if="catalogo.erro" text @click="recarregar">Tentar novamente</v-btn>
        </v-alert>
        <v-select v-model="sold" :items="ativas" :item-text="rotulo" item-value="sold" outlined
          label="Escolha a distribuidora" :loading="catalogo.carregando" :disabled="!!catalogo.erro" />
        <p v-if="sold">Ao confirmar, este cliente ficará vinculado a {{ rotulo(selecionada) }}.</p>
      </v-card-text>
      <v-card-actions><v-spacer /><v-btn text :disabled="salvando" @click="$emit('fechar')">Cancelar</v-btn>
        <v-btn color="primeira" :loading="salvando" :disabled="!sold || conflito || !!catalogo.erro" @click="salvar">Confirmar vínculo</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import { urlApi } from "@/global";
import { catalogo, carregarDistribuidoras, descricaoDistribuidora, mensagemErro } from "@/services/distribuidoras";
export default {
  name: "VinculoDistribuidora",
  props: { cliente: Object },
  data: () => ({ catalogo, sold: null, erro: "", conflito: false, salvando: false }),
  computed: {
    ativas() { return catalogo.itens.filter(d => d.ativa && d.sold !== (this.cliente && this.cliente.sold)); },
    selecionada() { return catalogo.itens.find(d => d.sold === this.sold); }
  },
  watch: { cliente() { this.sold = null; this.erro = ""; this.conflito = false; if (this.cliente) this.recarregar(); } },
  methods: {
    descricao: descricaoDistribuidora,
    rotulo: d => d ? d.nomeExibicao + " — SOLD " + d.sold : "",
    recarregar() { carregarDistribuidoras(true).catch(() => {}); },
    async salvar() {
      this.salvando = true; this.erro = "";
      try {
        const { data } = await axios.post(urlApi + "/definir-distribuidora-cliente", {
          clienteId: this.cliente.objectId, sold: this.sold, soldAnterior: this.cliente.sold == null ? null : this.cliente.sold
        });
        this.$emit("salvo", data.result);
        this.$emit("fechar");
      } catch (e) {
        this.erro = mensagemErro(e);
        if (e.response && e.response.data && e.response.data.code === 409) { this.conflito = true; this.$emit("atualizar"); }
      } finally { this.salvando = false; }
    }
  }
};
</script>

